<eze-smart-form-container>
	<div header>
		<h1>{{formName}} Registration</h1>
	</div>
	<div body>
		<h3 style="text-align: center; padding: 50px;">
			Sorry, something went wrong. Please try again later or on another device. If you still cannot register, please
			email us at <a [href]="mailToLink" target="_blank">{{email}}</a>
		</h3>
	</div>
	<div footer>
		<a [href]="url" class="btn btn-primary">
			Go to Event Page
		</a>
	</div>
</eze-smart-form-container>
